// extracted by mini-css-extract-plugin
export default {"p":"P_p__qMuDQ","buttonLink":"P_buttonLink__4CHGG","pMarkdown":"P_pMarkdown__FesiZ P_p__qMuDQ"};